import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createTrip,
  deleteTrip,
  duplicateTrip,
  listTrips,
  updateTrip,
} from '../../shared/api/trips'
import type { CreateTripInput, UpdateTripInput } from '../../shared/api/types'

export const tripKeys = {
  all: ['trips'] as const,
  detail: (id: string) => ['trips', id] as const,
}

export function useTrips() {
  return useQuery({ queryKey: tripKeys.all, queryFn: listTrips })
}

export function useCreateTrip() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateTripInput) => createTrip(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: tripKeys.all }),
  })
}

export function useUpdateTrip(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (patch: UpdateTripInput) => updateTrip(id, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: tripKeys.all })
      qc.invalidateQueries({ queryKey: tripKeys.detail(id) })
    },
  })
}

export function useDeleteTrip() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteTrip(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: tripKeys.all }),
  })
}

export function useDuplicateTrip() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => duplicateTrip(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: tripKeys.all }),
  })
}
